<fieldset disabled="disabled">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</fieldset>
